<div class="padding">
    <div class="carousel carousel-showmanymoveone slide" id="carousel-tilenav" data-interval="false">
        <div class="carousel-inner">
            <div class="panel panel-default">
                @if(isLoadingResults){
                    <div class="example-loading-shade">
                        @if(isLoadingResults){
                            <mat-spinner diameter="30"></mat-spinner>
                        }
                    </div>
                }
                <div class="panel-heading">
                    <p class="panel-title">
                        Pre-Submission Rejects &nbsp; 
                        @if(LastCATExecutionDate){
                            <span>{{ LastCATExecutionDate | date:'dd' }} - {{ LastCATExecutionDate | date:'MMM' }}</span>
                        }
                    </p>
                </div>
                <div class="col-lg-12 nopadding">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 nopadding">
                        <mat-card class="mat-elevation-z8" id="tableCard">
                            <mat-table class="highlight" #table [dataSource]="dataSource" matSort matSortActive="Rejects" matSortDirection="desc">
                                <!-- Dynamic -->
                                @for(col of displayedColumns; track col; let i = $index){
                                    <ng-container matColumnDef={{col}}>
                                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{col.replace('_', ' ')| titlecase }} </mat-header-cell>
                                        <mat-cell *matCellDef="let Exception">
                                            @if(col==='Reject_Code'){
                                                <span>
                                                    <a [id]="'rejectCode'+ Exception[col]" [matTooltip]="Exception['Exception_Description']" [matTooltipShowDelay]="1000" matTooltipPosition="after" [routerLink]=redirectUrl routerLinkActive="activeRoute" (click)="setMenu(Exception[col])"
                                                        (mouseover)="Route(Exception[col])">{{Exception[col]}} </a>
                                                </span>
                                            }
                                            @if(col != 'Reject_Code'){
                                                <span>{{Exception[col]}}</span>
                                            }
                                        </mat-cell>
                                    </ng-container>
                                }
                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                            </mat-table>    
                        </mat-card>
                        <mat-card class="mat-elevation-z8 ">
                            <div class="open-exception-mat-card">
                                <mat-card-header>
                                    <mat-card-title class="open-exception-mat-card-title">
                                        OPEN
                                    </mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <p class="open-exception-mat-card-count">
                                        <a (click)="setMenu('0012')" id="exceptionCount"  
                                        routerLink="/pages/CAT/CAT-Exception/"
                                        routerLinkActive="activeRoute">{{totalExceptions}}</a>
                                    </p>
                                    <span class="open-exception-mat-card-title">&nbsp;&#160;</span>
                                </mat-card-content>
                            </div>
                        </mat-card>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7 nopadding">
                        <canvas baseChart 
                        style="display: block;height: 199px;padding: 15px;width: 266px;"
                        id="preSubCanvas"
                        width="50%" 
                        height="42%" 
                        [data]="chartData" 
                        [type]="'pie'"
                        [options]="pieChartOptions" height="100vw" width="100vw"
                        >
                        </canvas>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 details-card">
                        <mat-card class="mat-elevation-z8">
                            <mat-card-header>
                                <mat-card-title style="margin-top: 3px !important;">
                                    <span>{{ LastCATExecutionDate | date:'MM/dd/yyyy' }} – Received {{this.UserService.ReceivedFilesCount}} Files / {{this.UserService.CATPreValidationROECount}} ROEs.</span>
                                </mat-card-title>
                            </mat-card-header>
                        </mat-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>